<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="alert alert-success" role="alert">
          ※ 멤버십 결제가 완료되었습니다. 감사합니다 ※
        </div>
      </div>
    </main>    
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions.js';
import moment from 'moment';
import {generateCouponCode_mem} from '../assets/js/genCode'
import {insPushHistory} from '../assets/js/push'                // push발송이력저장

export default {
  data() {
    return {
      handTel: [],            //매니저연락처
      handTelCnt: 0,          //수신처갯수
      memCpInfo: [],          //멤버십 전용할인기본정보
      insId_h: null,          //수동가입처리자(없음)
    };
  },
  created() {
    this.user = this.$store.state.user;

    if(this.user.email == undefined || this.user.email == null)
    {
      this.$swal.fire('결제정보누락', '결제에 필요한 정보가 부족합니다. 재로그인 후 진행해 주세요', 'question');
      this.$router.push({ path: "/" }); 
      return false;
    }

    this.paymentKey = this.$route.query.paymentKey;     //결제키
    this.orderId = this.$route.query.orderId;           //주문아이디
    this.amount = this.$route.query.amount;             //결제금액

    this.getHandlerInfo()                               //알림톡 발송대상 체크
    this.getMemberCouponInfo()                          //멤버십쿠폰정보체크
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  async mounted() {
    // [추가] created에서 리다이렉트된 경우에도 mounted는 실행되므로 여기서 중단
    //  (결제승인을 호출하지 않으면 토스 결제는 확정되지 않음)
    if(!this.user.email) return false;

    // [추가] 결제정보 없이 직접 접근 차단
    if(!this.paymentKey || !this.orderId || !this.amount)
    {
      this.$swal.fire('', '적절하지 않은 접근입니다.', 'error');
      this.$router.push({ path: "/" });
      return false;
    }

    this.total_amount = localStorage.getItem("total_amount")
    this.mLv = localStorage.getItem("memLevel")                  // ES, EP, U, N
    this.engName = localStorage.getItem("engName")
    this.uPassport = localStorage.getItem("uPassport")
    this.uPassportExp = localStorage.getItem("uPassportExp")
    this.memExpDate = localStorage.getItem("memExpDate")
    this.userTel = localStorage.getItem("userTel")              //멥버십가입자 연락처

    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
    }
    else 
    {
      this.isApp = false;
    }

    if(this.amount === this.total_amount)
    {
      await this.processPayment()
    }
    else
    {
      this.$swal.fire('', '멤버십금액과 결제금액이 불일치합니다. 문의: 1660-4602', 'error');
      this.$router.push({ path: "/" }); 
      return false;
    }
  },

  methods:
  {
    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },    
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    // [추가] 토스 결제승인 실패 판정
    //  $api는 에러를 throw하지 않고 undefined를 반환하므로 반환값으로 판단
    //  - undefined/null : HTTP 에러(4xx/5xx) 또는 통신 실패
    //  - res.error      : 백엔드 에러 객체
    //  - res.code       : 토스 에러응답 {code, message} (예: ALREADY_PROCESSED_PAYMENT)
    //  ※ 토스 승인성공 응답(Payment 객체)에는 최상위 code 필드가 없음
    isConfirmFailed(res) {
      if (!res) return true;
      if (res.error) return true;
      if (res.code) return true;
      return false;
    },

    // [추가] 결제승인 성공을 확인한 뒤에만 가입처리
    //  토스는 같은 결제를 두 번 승인하지 않으므로, 새로고침/뒤로가기/인앱브라우저 재진입 시
    //  두 번째 승인은 실패 → 가입·쿠폰이 다시 생성되지 않음
    //  (기존: 승인 실패해도 $api가 에러를 삼켜 .then()에서 가입처리가 진행됐음)
    async processPayment() {
      const toss_pg = {
        paymentKey: this.paymentKey,
        amount:     this.amount,
        orderId:    this.orderId
      }
      const confirmRes = await this.$api("/api/tossPG/success", { param: toss_pg });

      if(this.isConfirmFailed(confirmRes))
      {
        console.error("결제승인 실패:", confirmRes);
        this.$swal.fire('', '이미 처리되었거나 승인되지 않은 결제입니다.<br>마이페이지에서 멤버십 가입여부를 확인해 주세요.<br>문의: 1660-4602', 'warning').then(() => {
          this.$router.push({ path: "/myPage" });
        });
        return false;
      }

      await this.joinMembership();
    },

    // 백엔드에 푸시api 연결요청
    async push_appPoint(uId) {
      // 앱다운로드 감사포인트 푸시
      let pushMessages = 
      {
        userId: uId,
        title: "엔데이트립멤버십 가입을 환영합니다",
        content: "멤버십 전용쿠폰이 발급되었습니다",
        linkURL: "https://ntabi.co.kr/myPage",
        imageURL:"https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
      };

      let result = await this.$api("api/pushSend01", {
        param: [
          { pushMessages: pushMessages }
        ]
      });

      let arr_push = [];
      let pushHistory = [];

      // 푸싱성공->히스토리저장
      if(result == "Push successfully requested to be sent.") 
      {
        arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '200', 'ok', 'PE', 'Y', 'Y'];
        pushHistory = await insPushHistory(this.$api, arr_push);
      }
      else 
      {
        arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '', 'err', 'PE', 'Y', 'Y'];
        pushHistory = await insPushHistory(this.$api, arr_push);
      }

      if(pushHistory === "Y") 
      {
        console.log("History Save OK");
      }
      else 
      {
        console.log("History Save Fail");
      }
    },

    // 멤버십 전용 할인정보 체크
    async getMemberCouponInfo() {
      let memCpInfo = await this.$api("/api/memberCouponInfo", {param: [ 'MDC', 'Y' ] })
        
      if(Array.isArray(memCpInfo) && memCpInfo.length > 0)
      {
        this.memCpInfo = memCpInfo
      }
    },

    // [추가] 쿠폰 기본정보(A, B) 로딩여부
    hasMemCpInfo() {
      return ['A', 'B'].every(code => this.memCpInfo.some(e => e.procCode === code));
    },

    // 멤버십 쿠폰코드생성
    async genCpCode_mem(param) {
      let cpCode = ""
      
      if(param === "monthly") cpCode = "M"
      else if(param === "new") cpCode = "N"

      return await generateCouponCode_mem(this.$api, cpCode);
    },

    async joinMembership(){

      let mName = ""
      let imageUrl = ""
      let mShipFlag = "Y"
      let mUseFlag = "Y"
      let today = new Date();
      let yyyy = today.getFullYear()
      let mm_tmp = today.getMonth()+1
      let dd_tmp = today.getDate();

      let mm = "";
      if(mm_tmp < 10) {mm = "0" + mm_tmp}
      else mm = mm_tmp;

      let dd = "";
      if(dd_tmp < 10) {dd = "0" + dd_tmp}
      else dd = dd_tmp;


      let payDate = yyyy +"-" + mm + "-" + dd

      let oneYearLater_tmp
      let oneYearLater
      let paidFlag = "Y"        // 결제성공

      if(this.mLv == "P")
      {
        mName = "프리미엄멤버십"
      }
      else if(this.mLv == "S")
      {
        mName = "스탠다드멤버십"
      }
      else if(this.mLv == "N")
      {
        mName = "뉴멤버십"
      }
      else if(this.mLv == "U")
      {        
        mName = "멤버십업그레이드"
      }
      else if(this.mLv == "ES" || this.mLv == "EP")
      {
        mName = "멥버십기한연장"
      }

      if(this.mLv == "N")  //신멥버쉽가입(혜택기간반영)
      {
        // [추가] 쿠폰 기본정보가 아직 로딩 안 됐으면 대기 (기존: 로딩 전이면 멤버십만 생성되고 쿠폰발행에서 에러)
        if(!this.hasMemCpInfo())
        {
          await this.getMemberCouponInfo()
        }
        if(!this.hasMemCpInfo())
        {
          this.$swal.fire("", "멤버십 쿠폰정보를 불러오지 못했습니다.<br>고객센타(1660-4602)로 문의해 주세요", "error")
          return false;
        }

        // [추가] 이미 유효한 멤버십이 있으면 가입 중단 (다른 결제건으로 중복 결제된 경우)
        let activeMem = await this.$api("/api/checkMembershipInfo_new", {param: [this.user.email]});
        if(Array.isArray(activeMem) && activeMem.length > 0)
        {
          this.$swal.fire("", "이미 유효한 멤버십이 있어 가입처리를 중단했습니다.<br>중복 결제건은 고객센타(1660-4602)로 문의해 주세요", "warning").then(() => {
            this.$router.push({ path: "/myPage" });
          });
          return false;
        }

        // 1년 후의 날짜 계산
        oneYearLater_tmp = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
        // 계산된 날짜의 전일로 설정(기산일 전일이 멤버십 종료일)
        let oneYearLater_tmptmp = oneYearLater_tmp.setDate(oneYearLater_tmp.getDate() - 1);
        oneYearLater = moment(oneYearLater_tmptmp).format('YYYY-MM-DD HH:mm:ss');             // HH가 24시간제

        try
        {
          // 신멤버십 가입처리
          let res_joinMembership = await this.$api("/api/proc_joinMembership_new", {param: [
            mShipFlag, this.user.email,
            this.engName, this.uPassport, this.getDateFormat(this.uPassportExp), this.mLv, oneYearLater, mUseFlag, paidFlag, this.userTel, this.insId_h
          ]})

          // [수정] 응답 자체가 없는 경우(undefined)도 에러 처리
          if (!res_joinMembership || res_joinMembership.error) 
          {
            const errMsg = (res_joinMembership && res_joinMembership.error && res_joinMembership.error.sqlMessage) || ""
            this.$swal.fire(
              "에러 발생",
              "멤버십 가입 진행 중 오류가 발생했습니다: " + errMsg,
              "error"
            );
            console.error("프로시저 호출 에러:", res_joinMembership);
            return false;
          }

          if(this.mLv === "S")
          {
            imageUrl = '/IMGs/Standard.jpg'
          }
          else if(this.mLv === "P")
          {
            imageUrl = '/IMGs/Premium.jpg'
          }
          else if(this.mLv === "N")
          {
            imageUrl = '/IMGs/membership_popup.png'
          }

          // 멤버십쿠폰기본정보에서 쿠폰명, 할인수치, 할인유형(정액/정률)
          const cpInfo_A = this.memCpInfo.find(e => e.procCode === 'A');
          const cpInfo_B = this.memCpInfo.find(e => e.procCode === 'B');

          let memCpName_A = cpInfo_A.procName;
          let memCpName_B = cpInfo_B.procName;

          let memCpDcPrc_A = cpInfo_A.col_int1;
          let memCpDcType_A = cpInfo_A.col_char1;

          let memCpDcPrc_B = cpInfo_B.col_int1;
          let memCpDcType_B = cpInfo_B.col_char1;

          let cpUseFlag = "N"           //쿠폰사용여부:N미사용,Y사용
          let validFlag = "Y"           //쿠폰유효여부:Y유효,N무효

          let cpIssueQty_A = 12         //월할인쿠폰 발행매수
          let cpIssueQty_B = 1          //신규할인쿠폰 발행매수

          let cpCat_A = "L"             //적용상품 카테고리
          let cpCat_B = "NN"            //적용상품 카테고리

          let cpType_A = "monthly"
          let cpType_B = "new"

          let memCpType_A = "A"
          let memCpType_B = "B"

          let cpUseCode = "CA"          //적용대상(전체상품AL, 전체유저AU, 특정카테고리CA, 특정상품PD, 제휴제외 엔타비NT)
          let cpWithPoint = "N"        //포인트동시사용여부:Y동시사용,N단독사용

          // 1. montly용 전용쿠폰번호(sub에 12매)과 new용 전용쿠폰번호(sub에 1매) 생성
          let cpCode_monthly = await this.genCpCode_mem("monthly")

          // 2. new용 전용쿠폰번호 -> 마스터에만 등록
          let cpCode_new = await this.genCpCode_mem("new")

          // 월할인 쿠폰마스터 & 월별쿠폰
          let cpMonthlyDC = await this.$api("/api/proc_createMemCoupon_new_new", {param: [
            cpType_A, this.user.email, cpCode_monthly, memCpName_A, oneYearLater, cpUseFlag, memCpDcPrc_A, memCpDcType_A, memCpType_A, validFlag,
            cpType_A, cpIssueQty_A, cpUseCode, cpCat_A, this.userTel, cpWithPoint
          ]})

          // [수정] 응답 없음(undefined)도 실패로 처리
          if(!cpMonthlyDC || cpMonthlyDC.out_success === "0") 
          {
            this.$swal.fire("", "멤버십 전용 월할인 쿠폰 생성에 문제가 발생했습니다.<br>고객센타(1660-4602)로 문의해 주세요", "warning")
            return false;
          }

          // 신규상품 할인쿠폰
          let cpNewDC = await this.$api("/api/proc_createMemCoupon_new_new", {param: [
            cpType_B, this.user.email, cpCode_new, memCpName_B, oneYearLater, cpUseFlag, memCpDcPrc_B, memCpDcType_B, memCpType_B, validFlag,
            cpType_B, cpIssueQty_B, cpUseCode, cpCat_B, this.userTel, cpWithPoint
          ]})
          if(!cpNewDC || cpNewDC.out_success === "0") 
          {
            this.$swal.fire("", "멤버십 전용 신규상품 할인쿠폰 생성에 문제가 발생했습니다.<br>고객센타(1660-4602)로 문의해 주세요", "warning")
            return false;
          }

          // 가입완료 안내 후 재로그인 유도
          this.$swal.fire({
              html: '</br>멤버십 가입을 환영합니다! <br> 로그인 후 다양한 혜택을 누려보세요!',
              imageUrl: imageUrl,
              imageWidth: 300,
              imageHeight: 300,
              imageAlt: 'Join membership',
            }).then(() => {
              this.sendKakao("MJO", payDate, oneYearLater, this.mLv)
          })

          return true;
        }
        catch(error) 
        {
          console.error("프로시저 호출 에러:", error);
          return false;
        }
      }

      else if(this.mLv == "EP" || this.mLv == "ES")  //멤버십연장
      {
        let currentDate = new Date(this.memExpDate);
        oneYearLater_tmp = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), 1);
        // 해당 달의 말일로 설정
        oneYearLater = this.getDateFormat(oneYearLater_tmp.setMonth(oneYearLater_tmp.getMonth() + 1, 0))

        try
        {
          let memberRenewal = await this.$api("/api/proc_memberRenewal", {param: [
            this.user.email,
            this.engName, this.uPassport, this.getDateFormat(this.uPassportExp), oneYearLater
          ]})

          // [수정] 응답 없음(undefined)도 에러 처리
          if (!memberRenewal || memberRenewal.error) {
            const errMsg = (memberRenewal && memberRenewal.error && memberRenewal.error.message) || ""
            this.$swal.fire(
              "에러 발생",
              "멤버십 가입 진행 중 오류가 발생했습니다: " + errMsg,
              "error"
            );
            console.error("프로시저 호출 에러:", memberRenewal);
            return false;
          }

          if(this.mLv === "ES")
          {
            imageUrl = '/IMGs/Standard.jpg'
          }
          else if(this.mLv === "EP")
          {
            imageUrl = '/IMGs/Premium.jpg'
          }

          this.$swal.fire({
            html: '<b class="text-success">'+ mName + '</b>이 완료되었습니다.<br>재로그인 후 엔데이트립 일일버스투어를 무제한으로 누려보세요.',
            imageUrl: imageUrl,
            imageWidth: 300,
            imageHeight: 300,
            imageAlt: 'Renewal membership',
          })
          this.sendKakao("MEX", payDate, oneYearLater, this.mLv)

          return true;
        }
        catch(error)
        {
          console.log("ProcError:", error)
          return false;
        }
      }

      else
      {
        this.$swal.fire("","처리 중 문제가 발생했습니다.<br>문의처: 1660-4602","warning")
        return false;
      }
    },

    toB2CLogout() {
      window.Kakao.Auth.logout((response) => {
        this.$store.commit("user", {});       // 로그아웃->카카오유저 정보를 빈값으로 대체
        
        window.sessionStorage.clear();        // 로그아웃->세션스토리지를 모두 삭제
        window.localStorage.clear();
        console.log(response);
        
        location.href = "/"
      });
    },

    /** 직원정보추출 */
    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    /** 카카오알림 발송 */
    async sendKakao(param, payDate, expDate, mLv)  //param: P, S
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        this.user.email, param, this.user.alimCallC
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.user.alimCallC})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory && insKSendHistory.affectedRows > 0) 
      {
        let membership = ""
        if(mLv === "P" || mLv == "U")
        {
          membership = "엔데이트립 프리미엄멤버십"
        }
        else if(mLv == "S") 
        {
          membership = "엔데이트립 스탠다드멤버십"
        }
        else if(mLv == "N") 
        {
          membership = "엔데이트립 New멤버십"
        }        
        else if(mLv == "ES" || mLv == "EP") 
        {
          membership = "엔데이트립 멤버십연장"
        }        

        let promises = []

        //결제요청 카카오 알림톡(결제자)
        let i = 0
        while(i < this.handTelCnt)
        {
          let kakaoAlimData = 
          {
            //카카오 알림톡 발송(결제완료)
            clientName: this.user.nickname,
            membership: membership,
            memPayDate: payDate,
            memPayAmt: this.getCurrencyFormat(this.total_amount),
            memExpDate: expDate,
            resCode: "",
            alimFlag: param, //알림유형(결제요청)
            clientCall: this.handTel[i].aimCall,       //알림톡발송대상
          };
          let promise = this.$api("api/kakaoAlimSend8", {param: [{ kakaoAlimData: kakaoAlimData}]})
          promises.push(promise)
          i++
        }
        //반복문 이후 처리
        Promise.all(promises).then(() => {
          this.$swal.fire('', '멤버십결제완료 알림톡이 발송되었습니다', 'success').then((res) => {
            console.log(res)

            this.push_appPoint(this.user.email)   //앱푸시
            
            this.toB2CLogout()
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
          this.toB2CLogout()
        })
      }
    },
  }
}
</script>